import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const productDetails_apis = API_URLs.productDetails;

export const apiCall_getVerifiedProductDetails = async (productId) => {
  return http.get(
    productDetails_apis.getVerifiedProductDetails + "?ProductId=" + productId
  );
};

export const apiCall_getWaitingProductDetails = async (productId) => {
  return http.get(
    productDetails_apis.getWaitingProductDetails + "?ProductId=" + productId
  );
};

export const apiCall_getVerifiedInventory = async (productId) => {
  return http.get(
    productDetails_apis.getVerifiedInventory + "?ProductId=" + productId
  );
};

export const apiCall_getWaitingInventory = async (productId) => {
  return http.get(
    productDetails_apis.getWaitingInventory + "?ProductId=" + productId
  );
};

export const apiCall_getQuestions = async (productId) => {
  return http.get(productDetails_apis.getQuestions + "?ProductId=" + productId);
};

export const apiCall_getComments = async (productId) => {
  return http.get(productDetails_apis.getComments + "?ProductId=" + productId);
};

export const apiCall_addAndAnswerFaq = async ({
  productId,
  Question,
  Answer,
}) => {
  return http.post(
    productDetails_apis.addAndAnswerFaq +
      "?ProductId=" +
      productId +
      "&Question=" +
      Question +
      "&Answer=" +
      Answer
  );
};

export const apiCall_deleteVerifiedProduct = async (id) => {
  return http.delete(productDetails_apis.deleteVerifiedProduct + "?id=" + id);
};

export const apiCall_deleteWaitingProduct = async (id) => {
  return http.delete(productDetails_apis.deleteWaitingProduct + "?id=" + id);
};

export const apiCall_deleteVerifiedProductSample = async (id) => {
  return http.delete(
    productDetails_apis.deleteVerifiedProductSample + "?id=" + id
  );
};

export const apiCall_deleteWaitingProductSample = async (id) => {
  return http.delete(
    productDetails_apis.deleteWaitingProductSample + "?id=" + id
  );
};

export const apiCall_editProduct = async (data) => {
  const form = new FormData();

  form.append("ProductId", data.ProductId);
  form.append("Title", data.Title);
  form.append("Description", data.Description);
  form.append("SellerFeatures", data.SellerFeatures);
  form.append("Tags", data.Tags);

  if (data?.Features?.length > 0) {
    data?.Features?.forEach((item, index) => {
      const key = Object.keys(item)[0];
      form.append(
        "Features[" + index + "].FeatureId",
        key.toString().replace("keyValueFeature-", "")
      );
      if (key.startsWith("keyValueFeature-")) {
        form.append(
          "Features[" + index + "].FeatureValue",
          item[key.toString()]
        );
      } else {
        form.append(
          "Features[" + index + "].FeatureOptionId",
          item[key.toString()]
        );
      }
    });
  }

  return http.post(productDetails_apis.editProduct, form);
};

export const apiCall_addProductEntity = async (queryString) => {
  return http.post(productDetails_apis.addProductEntity + queryString);
};
